<template>
	<!-- App -->
  <div class="page">
    <div class="showSmallScreenOnly" v-bind:class="colorBottomButton">
      <f7-fab class="leftfav button-fab bottomButton floatingButtonToolbarBlank" @click="extractCSV()">
        <f7-icon f7="document_text"></f7-icon>
      </f7-fab>
    </div>
    <div class="page-content">
  		<page-nav-bar currentServiceName="MoneyRoad" popoverName=".popoverBanks" subNavTitle="Statements" :menuAccess="true"></page-nav-bar>
      <div class="row rowBackgroundImage" v-bind:class="colorBottomButton">
        <div class="row showLargeScreenOnly rowSearchBar">
          <div class=" firstButtonMarginLeft showLargeScreenOnly">
            <button class="new-button milkyBlock boxRequest" @click="extractCSV()">
                <f7-icon f7="document_text"></f7-icon>
                <span>{{ $t('common.extract_csv') }}</span>
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
      		<f7-searchbar class="search"
      			id="searchBankAccount"
      			cancel-link="Cancel"
      			search-list="#bank-list"
      			placeholder="Search in Accounts"
            @searchbar:search="onSearch"
            @searchbar:clear="onClear">
      		</f7-searchbar>
        </div>
      </div>
  		<div class="layoutSubtitle"/>
  		<f7-list class="searchbar-not-found">
        <f7-list-item title="Nothing found"></f7-list-item>
      </f7-list>
      <cm-bank-accounts-list-statement :bankAccounts="bankAccounts" :filterBy="filterBy"></cm-bank-accounts-list-statement>
      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
</template>

<script>

import BankAccountsListStatement from './CMBankAccountsPage/CMBankAccountsListStatement.vue'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import {formatIbanHidden, formatIbanUKHidden} from '@/helpers/format'
import moment from 'moment'
import Vue from 'vue'

export default {
  name: 'ImportBankAccountReportList',
  components: {
    // 'cm-bank-import-report-list': BankAccountsImportReportList,
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar,
    'cm-bank-accounts-list-statement': BankAccountsListStatement
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      bankAccountSelected: '',
      bankAccounts: [],
      filterBy: ''
    }
  },
  created () {
    this.$bus.on('refresh-bank-accounts-list-statement', () => {
      this.bankAccounts = []
      this.bankAccounts = this.$engine.bankAccounts.get()
      this.bankAccountSelected = this.$engine.bankAccounts.getIbanStatment()
    })
    this.$bus.emit('refresh-bank-accounts-list-statement')
    this.bankAccounts = this.$engine.bankAccounts.get()
    this.bankAccountSelected = this.$engine.bankAccounts.getIbanStatment()
    /* Messages de log à décommenter pour déboguer les statements des ML
    console.log('bank accounts: ')
    console.log(this.bankAccounts) */
    for (var i in this.bankAccounts) {
      if (this.bankAccounts[i].balances !== undefined && this.bankAccounts[i].balances.length > 0) {
        /* TLV 07/01/2020
        * Pour chaque compte bancaire, les balances associées doivent être triées
        * de la plus ancienne à la plus récente (execution_date)
        */
        this.bankAccounts[i].balances.sort(function (date1, date2) {
          return (date1.execution_date < date2.execution_date) ? -1 : ((date1.execution_date > date2.execution_date) ? 1 : 0)
        })

        this.bankAccounts[i].initialAmount = this.bankAccounts[i].opbd_amount
        /* Pour les autres valeurs, on calc le remaining amount nous-mêmes par rapport à la valeur précédente */
        for (var k = 0; k < this.bankAccounts[i].balances.length; k++) {
          let priorIndex = k - 1
          if (k === 0) {
            /* printed_opbd_amount correspond à la valeur affichée à l'écran. A la première ligne, il s'agit de la valeur de opbd_amount */
            priorIndex = k
            this.bankAccounts[i].balances[priorIndex].printed_opbd_amount = this.bankAccounts[i].opbd_amount
            /* Messages de log à décommenter pour déboguer les statements des ML
            console.log('first opbd amount')
            console.log(this.bankAccounts[i].balances[priorIndex].printed_opbd_amount) */
          }
          let total = 0
          if (this.bankAccounts[i].balances[k].credit_debit_indicator === 'DBIT') {
            total = parseFloat(this.bankAccounts[i].balances[priorIndex].printed_opbd_amount) - parseFloat(this.bankAccounts[i].balances[k].amount)
          } else {
            /* Messages de log à décommenter pour déboguer les statements des ML
            console.log('opbd amount calc')
            console.log(this.bankAccounts[i].balances[priorIndex].printed_opbd_amount)
            console.log(this.bankAccounts[i].balances[k])
            console.log(this.bankAccounts[i].balances[k].amount) */
            total = parseFloat(this.bankAccounts[i].balances[priorIndex].printed_opbd_amount) + parseFloat(this.bankAccounts[i].balances[k].amount)
          }
          this.bankAccounts[i].balances[k].printed_opbd_amount = total.toFixed(2)
        }
      }
    }
  },
  computed: {
    filteredBankAccounts () {
      let that = this
      let result = []
      if (this.filterBy) {
        for (var k in that.bankAccounts) {
          if (that.bankAccounts[k].name.toLowerCase().includes(this.filterBy.toLowerCase())) {
            result.push(that.bankAccounts[k])
          }
        }
        return result
      }

      return this.bankAccounts
    },
    getReport () {
      return this.report
    }
  },
  methods: {
    // Extraction CSV des statements
    extractCSV () {
      let lines = ''
      let extractedBankAccounts = this.filteredBankAccounts
      // Adaptation pour un IBAN. Reste à adapter au filtre de recherche
      if (this.bankAccountSelected !== '') {
        extractedBankAccounts = []
        for (var p in this.bankAccounts) {
          if (this.bankAccounts[p].iban.toLowerCase() === this.bankAccountSelected.toLowerCase()) {
            extractedBankAccounts.push(this.bankAccounts[p])
          }
        }
      }
      for (var account in extractedBankAccounts) {
        if (extractedBankAccounts[account].balances.length > 0) {
          lines += 'Account Name;IBAN;Date;End To End Id;Reference;Second Party Name;Value;Remaining Amount \r\n'
          lines += extractedBankAccounts[account].name + ';' + extractedBankAccounts[account].iban + ';' + Vue.filter('formatDate')(extractedBankAccounts[account].opbd_date) + ';;;;;' + extractedBankAccounts[account].initialAmount + '\r\n'
          for (var k = 0; k < extractedBankAccounts[account].balances.length; k++) {
            lines += extractedBankAccounts[account].name + ';' + extractedBankAccounts[account].iban + ';'
            lines += Vue.filter('formatDate')(extractedBankAccounts[account].balances[k].execution_date) + ';'
            lines += extractedBankAccounts[account].balances[k].end_to_end_id + ';'
            lines += extractedBankAccounts[account].balances[k].reference + ';'
            lines += extractedBankAccounts[account].balances[k].creditor_debtor_name + ';'
            if (extractedBankAccounts[account].balances[k].credit_debit_indicator === 'DBIT') {
              lines += '-'
            } else {
              lines += '+'
            }
            lines += extractedBankAccounts[account].balances[k].amount + ';'
            lines += extractedBankAccounts[account].balances[k].printed_opbd_amount + ';\r\n'
          }
          // Derniere ligne
          lines += extractedBankAccounts[account].name + ';' + extractedBankAccounts[account].iban + ';'
          lines += Vue.filter('formatDate')(extractedBankAccounts[account].balances[extractedBankAccounts[account].balances.length - 1].execution_date) + ';;;;;'
          lines += extractedBankAccounts[account].balances[extractedBankAccounts[account].balances.length - 1].printed_opbd_amount + '\r\n'
        }
      }

      const linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(lines)
      const downloadLink = document.createElement('a')
      let today = moment()
      var fileName = 'Statements' + today.unix() + '.csv'
      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },
    onSearch: function (query, found) {
      this.filterBy = query
    },
    onClear: function () {
      this.filterBy = ''
    },
    getClassStatus (value) {
      var color = ''
      if (value === 1) {
        color = 'icon-account-green-bank'
      } else {
        color = 'icon-account-red-bank'
      }
      return color
    },
    formatIban (iban, zone) {
      if (zone === 'UK') {
        return formatIbanUKHidden(iban)
      } else {
        return formatIbanHidden(iban)
      }
    }
  }
}
</script>

<style>
.col-md {
  margin-right: 0%;
}
.rowBackgroundImage {
  background-image: url('../../assets/static/images/MenuFont.png');
  background-size: contain;
}
</style>



// WEBPACK FOOTER //
// CMListStatementBankAccount.vue?69192fde